<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="headline">
        Dodaj kupuj odpady
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-text-field
                  v-model="form.name"
                  class="pt-0"
                  type="text"
                  label="Imię i nazwisko"
                  :rules="formRules.name"
              ></v-text-field>
              <v-text-field
                  v-model="form.title"
                  class="pt-0"
                  type="text"
                  label="Tytuł"
                  :rules="formRules.title"
              ></v-text-field>
              <v-textarea
                  v-model="form.description"
                  class="pt-0"
                  type="text"
                  label="Opis"
                  :rules="formRules.description"
              ></v-textarea>
              <v-text-field
                  v-model="form.email"
                  class="pt-0"
                  type="text"
                  label="E-mail"
                  :rules="formRules.email"
              ></v-text-field>
              <v-text-field
                  v-model="form.phone"
                  class="pt-0"
                  type="text"
                  label="Numer telefonu"
                  :rules="formRules.phone"
              ></v-text-field>
              <v-text-field
                  v-model="form.code"
                  class="pt-0"
                  type="text"
                  label="Kod"
              ></v-text-field>
              <v-text-field
                  v-model="form.quantity"
                  class="pt-0"
                  type="number"
                  label="Ilość"
                  :rules="formRules.quantity"
              ></v-text-field>
              <v-text-field
                  v-model="form.boughtQuantity"
                  class="pt-0"
                  type="number"
                  label="Zakupiona ilość"
              ></v-text-field>
              <v-autocomplete
                  v-model="form.category"
                  :items="categories"
                  :search-input.sync="categoryQuery"
                  cache-items
                  item-text="name"
                  item-value="id"
                  flat
                  hide-no-data
                  label="Kategoria"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                large
            >Zapisz&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalAddWantBuy',
  props: {
    item: {},
  },
  created() {
  },
  mounted() {
    this.fetchAllCategories();
  },
  data() {
    return {
      dialog: false,
      form: {
        name: '',
        phone: '',
        email: '',
        boughtQuantity: 0,
        quantity: 0,
        code: '',
        category: null,
        title: '',
        description: '',
      },
      categoryQuery: null,
      categories: [],
      categoryAutoComplete: {
        loading: false,
        items: [],
      },
      formRules: {
        name: [(value) => !!value || 'Wpisz imię i nazwisko'],
        email: [(value) => !!value || 'Wpisz adres e-mail'],
        phone: [(value) => !!value || 'Wpisz numer telefonu'],
        title: [(value) => !!value || 'Wpisz tytuł'],
        description: [(value) => !!value || 'Wpisz opis'],
        quantity: [(value) => !!value || 'Wpisz ilość'],
        category: [(value) => !!value || 'Wybierz kategorię'],
      },
      valid: false,
    }
  },
  watch: {
    categoryQuery(value) {
      this.filterCategories(value);
    },
  },
  methods: {
    open() {
      this.dialog = true
    },
    fetchAllCategories() {
      if (this.categoryAutoComplete.loading || this.categories.length) {
        return;
      }

      this.categoryAutoComplete.loading = true;
      api.get('/api/categories')
          .then((response) => {
            const mappedCategories = {};
            const categories = response.data.categories;

            categories.forEach((category) => {
              mappedCategories[category.id] = category;
            });
            this.categories = categories;
            this.mappedCategories = mappedCategories;
          })
          .catch((e) => {
            console.error('Error:', e);
          })
          .finally(() => {
            this.categoryAutoComplete.loading = false;
          });
    },
    filterCategories(query) {
      this.categoryAutoComplete.loading = true;
      query = query.toLowerCase().trim();
      const categories = this.categories;
      const mappedCategories = this.mappedCategories;
      const items = [];
      let category, codes, parent, text, breadcrumb;

      for (let i = 0; i < categories.length; i++) {
        category = categories[i];
        codes = category.codes.join(', ').trim();

        if (category.name.toLowerCase().trim().includes(query) ||
            codes.includes(query)
        ) {
          parent = category.parentId
              ? mappedCategories[category.parentId]
              : null;
          text = category.name;

          if (category.requirePhoto) {
            text += ' (WYMAGA ZDJĘCIA)';
          }

          breadcrumb = '';

          if (parent) {
            const parentCategoryName = String(parent.name).trim();

            if ('' !== parentCategoryName) {
              breadcrumb = `W kategorii: ${parentCategoryName}`;
            }
          }

          items.push({
            id: category.id,
            name: category.name,
            text: text,
            codes: codes,
            parentId: category.parentId,
            parent: parent
                ? {
                  id: parent.id,
                  name: parent.name,
                }
                : null,
            unit: category.unit,
            slug: category.slug,
            breadcrumb: breadcrumb,
          });
        }
      }

      this.categoryAutoComplete.items = items;
      this.categoryAutoComplete.loading = false;
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      api
          .post('/api/offer/want-buys', this.form)
          .then(() => {
            this.$parent.getList();
            this.dialog = false;
          })
          .catch((error) => {
            console.error('Error when editing a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
